import { useLang } from "@/context/LangContext";
import { MessageSquare, Compass } from "lucide-react";

export function WhyNxT({ compact = false }) {
  const { t } = useLang();
  const gpt = ["gpt1", "gpt2", "gpt3", "gpt4", "gpt5"];
  const nxt = ["nxt1", "nxt2", "nxt3", "nxt4", "nxt5"];
  return (
    <section data-testid="why-nxt" className={compact ? "" : "mx-auto max-w-4xl px-5"}>
      {!compact && (
        <div className="mb-8 max-w-2xl">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-indigo-600">{t("whyLabel")}</div>
          <h2 className="mt-3 font-display text-3xl font-bold tracking-tight sm:text-4xl">{t("whyTitle")}</h2>
        </div>
      )}
      <div className="grid gap-3 sm:grid-cols-2">
        <div className="rounded-3xl border border-border bg-card p-5">
          <div className="flex items-center gap-2 text-muted-foreground"><MessageSquare className="h-4 w-4" /><span className="text-xs font-bold uppercase tracking-widest">ChatGPT</span></div>
          <ul className="mt-3 space-y-2 text-sm text-muted-foreground">{gpt.map((k) => <li key={k}>· {t(k)}</li>)}</ul>
        </div>
        <div className="rounded-3xl bg-slate-900 p-5 text-white">
          <div className="flex items-center gap-2 text-amber-300"><Compass className="h-4 w-4" /><span className="text-xs font-bold uppercase tracking-widest">NxT</span></div>
          <ul className="mt-3 space-y-2 text-sm">{nxt.map((k) => <li key={k} className="font-semibold">· {t(k)}</li>)}</ul>
        </div>
      </div>
      <p className="mt-5 text-center font-display text-lg font-extrabold tracking-tight sm:text-xl">
        <span className="text-muted-foreground">{t("whyLine1")}</span><br /><span className="text-indigo-600">{t("whyLine2")}</span>
      </p>
    </section>
  );
}
